// Liest middleware-injizierte Meta-Tags für Tenant-Branding

/**
 * Reads a middleware-injected meta tag by name from the document head.
 * Returns empty string when document is unavailable (SSR / test without DOM).
 */
export function readMeta(name: string): string {
  if (typeof document === "undefined") return "";
  return document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)?.content ?? "";
}
